import t from 'typy'

export default class SearchedTasksArray {

  keysToSearch = ['client.name', 'project.name', 'notes']

  constructor(tasks, text) {
    this._found = []
    this._searchRegExp = new RegExp(text, 'i')

    this.search(tasks)
  }

  search(tasks) {
    tasks.forEach(task => this.searchInTask(task))
  }

  searchInTask(task) {
    this.keysToSearch.some(key => {
      const valueToLook = t(task, key).input
      const result = this._searchRegExp.exec(valueToLook)
      if (result) {
        this._found.push(task.id)
        return true // terminate loop
      }
    })
  }

  isFound(task) {
    return this._found.includes(task.id)
  }
}



// WEBPACK FOOTER //
// ./src/views/agenda/SearchedTasksArray.js